export default __webpack_public_path__ + "static/media/tpp-unlimited-consults-at-clinic.3185cc15.svg";